export default class HistoryEvents {
    static init() {
        const html = document.querySelector('html');
        const replaceState = window.history.replaceState;
        window.history.replaceState = function () {
            replaceState.apply(window.history, arguments);
            html.dispatchEvent(new CustomEvent('history.replaceState'))
        };

        const pushState = window.history.pushState;
        window.history.pushState = function () {
            pushState.apply(window.history, arguments);
            html.dispatchEvent(new CustomEvent('history.pushState'))
        };
    }
}

HistoryEvents.init();